import { render, staticRenderFns } from "./InventorySettings.vue?vue&type=template&id=d70913f8&scoped=true"
import script from "./InventorySettings.vue?vue&type=script&lang=js"
export * from "./InventorySettings.vue?vue&type=script&lang=js"
import style0 from "./InventorySettings.vue?vue&type=style&index=0&id=d70913f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70913f8",
  null
  
)

export default component.exports